import React, { useState } from "react";
import "../layout/css/style.css";
import Footer from "../layout/Footer.js";
import FAQ from "../widgets/WidgetFAQPatna.js";
import Lead_Form from "../widgets/forms/price/widget-action-form.js";
import ShortLeadForm from "../widgets/forms/price/short-lead-form.js";
import mentalhealth from "../assets/Images/banner-hearing-aids-price.webp";
import Bookhearingtest from "../assets/Images/book-a-free-hearing-test.webp";
import BTE from "../assets/Images/bte.webp";
import CIC from "../assets/Images/cic_beige.webp";
import RechargeableHA from "../assets/Images/signia-rechargeable.webp";
import maplocation from "../assets/Images/map-location.webp";
import BluetootHA from "../assets/Images/Phonak-Audeo-Paradise.webp";
import LeadForm from "../widgets/forms/widget-action-form.js";
import { Helmet } from "react-helmet";
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import signiaImg from "../assets/Images/privileged-partner-signia.webp";
import phonakImg from "../assets/Images/authorised-partner-phonak.webp";
import resoundImg from "../assets/Images/authorised-partner-resound.webp";

const CentrePatna = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta http-equiv="x-ua-compatible" content="ie=edge" />
        <title>Best Hearing Aids Centre in Patna - Affordable Prices</title>
        <meta name="description" content="Purchase your hearing aids once you are fully satisfied with listening experience. Book your hearing aid trial now." />
        <meta name="robots" content="INDEX, FOLLOW" />
        <link rel="canonical" href="https://ads.soundforlife.in/hearing-aids-centre-patna" />
        <meta name="DC.title" content="Best Hearing Aids Centre in Patna - Affordable Prices" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content=" Sound For Life Hearing Solutions" />
        <meta property="og:title" content="Best Hearing Aids Centre in Patna - Affordable Prices" />
        <meta property="og:description" content="Purchase your hearing aids once you are fully satisfied with listening experience. Book your hearing aid trial now." />
        <meta property="og:type" content="Website" />
        <meta property="og:image" content="https://ads.soundforlife.in/assets/images/og-image.jpg" />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Best Hearing Aids Centre in Patna - Affordable Prices" />
        <meta property="og:url" content="https://ads.soundforlife.in/hearing-aids-centre-patna" />
        <link rel="preload" as="image" href="../assets/Images/banner-hearing-aids-price.webp" type="image/webp" />

      </Helmet>
      {/* Header Section */}
      <header className="bg-primary bg-opacity-50 py-5">
        <div className="container">
          <div className="row align-items-center g-5">

            {/* Banner Column */}
            <div className="col-lg-7 position-relative">
              <div className="position-relative">
                <img
                  src={mentalhealth} width="190" height="143" alt="hearing aids"

                  className="img-fluid w-100 rounded shadow lcp-img" fetchpriority="high"

                />    {/* style={{ height: '100%', objectFit: 'cover', maxHeight: '500px' }}*/}
                <div className="banner-overlay position-absolute bottom-0 start-0 w-100 bg-dark bg-opacity-50 text-white p-4">
                  <h1 className="h2 h1-md fw-bold">Top Hearing Aids Centre in Patna</h1>
                  <p className="mb-0">
                    <span className="tag bg-success fw-bold me-2">
                      <i className="fa-solid fa-users me-1"></i> Trusted by Thousands
                    </span>
                    <span className="tag bg-success fw-bold me-2">
                      <i className="fa-solid fa-microchip me-1"></i> Advanced Technology
                    </span>
                    <span className="tag bg-success fw-bold">
                      <i className="fa-solid fa-indian-rupee-sign me-1"></i> Affordable Prices
                    </span>
                  </p>
                </div>
              </div>
            </div>

            {/* Form Column */}
            <div className="col-lg-5">

              <Lead_Form />
            </div>

          </div>
        </div>
      </header>

      {/* Main Content Section */}
      <div className="container py-5">
        {/* Bullet Points */}
        <div className="mb-4 text-center">
          <span className="d-block d-md-inline-block mb-2 me-md-3 fs-4">
            <i className="fa-solid fa-check-circle text-success me-1"></i> Hearing Test
          </span>
          <span className="d-block d-md-inline-block mb-2 me-md-3 fs-4">
            <i className="fa-solid fa-check-circle text-success me-1"></i> Branded Digital Hearing Aids
          </span>
          <span className="d-block d-md-inline-block fs-4">
            <i className="fa-solid fa-check-circle text-success me-1"></i> Expert Audiologists
          </span>
        </div>

        {/* Intro */}
        {/*<h2 className="section-title">
          Welcome to SFL Hearing Solutions – Your Local Hearing Aid Experts
        </h2>*/}
        <h2 className="fw-bold display-6 title">Welcome to SFL Hearing Solutions: <span className="title-info">Your Local Hearing Aid Experts</span></h2>
        <p>
          <i className="fa-solid fa-location-dot text-primary me-1 font-icon" ></i>
          Looking for a reliable hearing aids centre or searching for a{' '}
          <span className="tag">hearing aid store near me?</span> SFL Hearing Solutions offers
          premium hearing care with advanced digital hearing aids, expert testing, and personalized
          fitting – all under one roof.
        </p>
        <p>
          Whether you need a kan ki machine, ear device for hearing loss, or a pocket hearing aid
          for profound hearing loss, we’ve got you covered.
        </p>

        {/* Why Choose */}
        <h2 className="section-title">Why Choose Our Hearing Aid Centres?</h2>
        <ul className="list-group list-group-flush">
          <li className="list-group-item list-group-item-primary">
            <i className="fa-solid fa-user-doctor font-icon me-2"></i>
            Certified Audiologists and Technicians
          </li>
          <li className="list-group-item list-group-item-primary">
            <i className="fa-solid fa-headset font-icon me-2"></i>
            Latest Hearing Machines from top brands
          </li>
          <li className="list-group-item list-group-item-primary">
            <i className="fa-solid fa-sliders font-icon me-2"></i>
            Customized Solutions for all hearing levels
          </li>
          <li className="list-group-item list-group-item-primary">
            <i className="fa-solid fa-building-columns font-icon me-2"></i>
            Clinics Across Patna
          </li>
          <li className="list-group-item list-group-item-primary">
            <i className="fa-solid fa-money-check-dollar font-icon me-2"></i>
            Affordable Pricing & Easy EMI
          </li>
        </ul>

        <div className="text-center mt-3">
          <a onClick={() => setIsFormOpen(true)} className="btn download-btn shadow fw-bold">
            <i className="fa-solid fa-calendar-plus me-2"></i> Book a Hearing Test
          </a> {isFormOpen && <LeadForm onClose={() => setIsFormOpen(false)} />}
        </div>

        {/* Locations */}
        <h2 className="mt-4">Multiple Clinics Across Patna:</h2>
        <div className="mb-3">
          <span className="tag fw-bold me-2">Patna</span>
          <span className="tag fw-bold me-2">Noida</span>
          <span className="tag fw-bold me-2">Gurgaon</span>
          <span className="tag fw-bold me-2">Ghaziabad</span>
          <span className="tag fw-bold">Faridabad</span>
        </div>

        {/* Services */}
        <section className="my-5">
          <h3 className="section-title mb-4">Our Hearing Aid Services</h3>
          <div className="row g-4">
            <div className="col-md-6 col-lg-3">
              <div className="card h-100 shadow-sm text-center p-4">
                <div className="text-primary display-4 mb-3">
                  <i className="fa-solid fa-headphones-simple font-icon"></i>
                </div>
                <h4 className="service card-title"> Hearing Tests</h4>
                <p className="card-text">
                  Complete Pure Tone Audiometry (PTA) and speech testing by certified experts.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card h-100 shadow-sm text-center p-4">
                <div className="text-primary display-4 mb-3">
                  <i className="fa-solid fa-ear-listen font-icon"></i>
                </div>
                <h4 className="service card-title">Hearing Aid Trials & Fitting</h4>
                <p className="card-text">
                  Try BTE, CIC, Bluetooth & rechargeable models with expert fitting.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card h-100 shadow-sm text-center p-4">
                <div className="text-primary display-4 mb-3">
                  <i className="fa-solid fa-screwdriver-wrench font-icon"></i>
                </div>
                <h4 className="service card-title">Maintenance & Repairs</h4>
                <p className="card-text">
                  We service all major brands like Signia, Phonak, Unitron, and more.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="card h-100 shadow-sm text-center p-4">
                <div className="text-primary display-4 mb-3">
                  <i className="fa-solid fa-person-cane font-icon"></i>
                </div>
                <h4 className="service card-title">Senior Citizen Friendly</h4>
                <p className="card-text">
                  Easy-to-use, comfortable ear machines designed for old age users.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* Hearing Aids Section */}
      <section className="container">
        <h4 className="section-title mb-4">Hearing Aids We Offer</h4>

        <div className="row justify-content-md-center g-4">
          {/* BTE */}
          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-sm">
              <img
                src={BTE} width="190" height="143" fetchpriority="high"
                alt="hearing aids"

                className="img-fluid w-100 rounded"
                style={{ height: '100%', objectFit: 'cover', maxHeight: '500px' }}
              />
              <div className="card-body">
                <h5 className="card-title">BTE (Behind the Ear)</h5>
                <p>
                  <i className="fa-solid fa-bolt  me-2 font-icon"></i>
                  <strong>Features:</strong> Powerful, Durable
                </p>
                <p>
                  <i className="fa-solid fa-children text-success me-2 "></i>
                  <strong>Ideal For:</strong> All Ages
                </p>
              </div>
            </div>
          </div>

          {/* CIC */}
          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-sm">
              <img
                src={CIC} width="190" height="143" fetchpriority="high"
                alt="hearing aids"

                className="img-fluid w-100 rounded"
                style={{ height: '100%', objectFit: 'cover', maxHeight: '500px' }}
              />
              <div className="card-body">
                <h5 className="card-title">CIC (Completely in Canal)</h5>
                <p>
                  <i className="fa-solid fa-eye-slash  me-2 font-icon"></i>
                  <strong>Features:</strong> Invisible, Discreet
                </p>
                <p>
                  <i className="fa-solid fa-briefcase text-success me-2"></i>
                  <strong>Ideal For:</strong> Working Professionals
                </p>
              </div>
            </div>
          </div>

          {/* Rechargeable */}
          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-sm">
              <img
                src={RechargeableHA} fetchpriority="high"
                width="190" height="143" alt="hearing aids"

                className="img-fluid w-100 rounded "
                style={{ height: '100%', objectFit: 'cover', maxHeight: '500px' }}
              />
              <div className="card-body">
                <h5 className="card-title">Rechargeable Aids</h5>
                <p>
                  <i className="fa-solid fa-battery-full  me-2 font-icon"></i>
                  <strong>Features:</strong> No battery hassle
                </p>
                <p>
                  <i className="fa-solid fa-user text-success me-2"></i>
                  <strong>Ideal For:</strong> Seniors
                </p>
              </div>
            </div>
          </div>

          {/* Bluetooth */}
          <div className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-sm">
              <img
                src={BluetootHA} fetchpriority="high"
                width="190" height="143" alt="hearing aids"

                className="img-fluid w-100 rounded "
                style={{ height: '100%', objectFit: 'cover', maxHeight: '500px' }}
              />
              <div className="card-body">
                <h5 className="card-title">Bluetooth Hearing Aids</h5>
                <p>
                  <i className="fa-solid fa-mobile-screen-button me-2 font-icon"></i>
                  <strong>Features:</strong> App Control
                </p>
                <p>
                  <i className="fa-solid fa-user-gear text-success me-2"></i>
                  <strong>Ideal For:</strong> Tech-savvy Users
                </p>
              </div>
            </div>
          </div>
        </div>

      </section>
      {/* What People Search */}
      <section className="container my-5">
        <h2 className="section-title">What People Search (And What We Provide)</h2>
        <p>
          <span className="tag me-2">best hearing aid in Patna</span>
          <span className="tag me-2">kan wali machine price</span>
          <span className="tag me-2">ear machine for hearing near me</span>
          <span className="tag me-2">digital hearing aids cost</span>
          <span className="tag me-2">ear machine in Patna</span>
          <span className="tag">signia near me</span>
        </p>
        <p className="fs-4">
          <i className="fa-solid fa-magnifying-glass text-primary me-2"></i>
          <strong>You search. We serve.</strong>
        </p>
      </section>

      {/* Clinic Locations */}
      <section className="container my-5">
        <h2 className="section-title">Visit the Nearest SFL Hearing Aid Centre</h2>
        <p>
          Just search for <span className="tag">ear hearing machine shop near me</span> or use the map below.
        </p>
        <div className="container">
          <div className="row align-items-center shadow rounded p-4">
            {/* Left side - Details */}
            <div className="col-md-8">
              <h3 className="location fw-bold">
                <i className="fa-solid fa-location-dot text-danger me-2"></i>Patna
              </h3>
              <address className="mb-3 fs-5">
                F-11, Gorakhnath Complex, Boring Road, <br />

                Patna, Bihar 800001 
              </address>
              <p className="fs-6">
                <i className="fa-solid fa-clock text-primary me-2"></i>
                <strong>Hours:</strong> Mon–Sat (10:00 AM - 07:00 PM)
              </p>
              <a
                href="https://maps.app.goo.gl/YAAFwPc5AzcRpL1x6"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-custom-add btn-sm"
              >
                <i className="fa-solid fa-map-location-dot me-2"></i> Get Directions
              </a>
            </div>

            {/* Right side - Map or Image */}
            <div className="col-md-4 text-center">
                           <a href="https://maps.app.goo.gl/YAAFwPc5AzcRpL1x6" target="_blank" rel="noopener noreferrer">
  <img
    src={maplocation}
    alt="noida Hearing Aid Centre"
    fetchpriority="high"
    className="img-fluid rounded shadow-sm"
  />
</a>
            </div>
          </div>
        </div>
      </section>


      {/* CTA Section */}
      <section className="container">
        <div className="container">
          <div className="cta-section text-center my-5">
            <p className="h4">
              <strong>
                <i className="fa-solid fa-volume-high me-2"></i> Let’s Help You Hear Again – Contact Us Now!
              </strong>
            </p>
            <p className="h5">
              Fill the form or call us today to book a hearing test at your nearest hearing aids
              centre.
            </p>
            <a
              href="tel:+919015401540"
              className="btn btn-custom btn-lg ms-3 d-none d-lg-inline fw-bold text-decoration-none"
            >
              <i className="fa-solid fa-phone me-2 mt-3"></i>Contact Us
            </a>
          </div>
        </div>
      </section>

      {/* Appointment Form */}
      <section className="enquiry-section py-5">
        <div className="container">
          <h4 className="form-title section-title fw-bold">Book a Hearing Test</h4>
          <div className="row align-items-center py-3 g-4">
            {/* Left Section */}
            <div className="col-lg-6 image-wrapper">
              <div className="image-box">
                <img src={Bookhearingtest} fetchpriority="high"
                  alt="Main" className="main-img" />

              </div>
            </div>

            {/* Right Section */}
            <div className="col-lg-6">

              <ShortLeadForm />

            </div>
          </div>
        </div>
      </section>

      {/* Brands Section */}
        <section className="container my-5">
        <h4 className="section-title mb-4">Brands We Deal In:</h4>
        <div className="row g-4">
          {[
            {
              brand: "Signia",
              image: signiaImg,
              models: "Silk, Pure, Motion, Insio",
            },
            {
              brand: "Phonak",
              image: phonakImg,
              models: "Audeo, Virto, Naida, Paradise",
            },
            {
              brand: "ReSound",
              image: resoundImg,
              models: "Nexia, Omnia, Key, Enzo, Magna",
            },
          ].map((item, idx) => (
            <div className="col-md-6 col-lg-4" key={idx}>
              <div className="card h-100 shadow-sm text-center p-4">
                <div className="mb-3">
                  <img src={item.image} className="card-img-top" alt={`${item.brand} Hearing Aids`} />
                </div>
                <h5 className="card-title">{item.brand}</h5>
                <p className="card-text">{item.models}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
<FAQ />
      {/* Testimonials Section */}
      <section className="container my-5">
        <h5 className="text-center mb-4">What Our Customers Say</h5>
        <div className="row g-4">
          {[
            {
              name: "Pankaj Thakur",
              review:
                "Sound for life is excellent... They have good trained audiologist... Thanx Dr. Mohana for your kind suggestion and treatment.",
              stars: 5,
            },
            {
              name: "Archana Singh",
              review:
                "I am very satisfied with the products and services... trust this clinic, this is really reliable.",
              stars: 4,
            },
            {
              name: "Praphul Fernandis",
              review:
                "The staff was attentive and knowledgeable... creating a comfortable environment... overall service left a lasting positive impression.",
              stars: 3.5,
            },
          ].map((t, idx) => (
            <div className="col-md-6 col-lg-4" key={idx}>
              <div className="card h-100 shadow-sm border-0 p-4">
                <div className="mb-3">
                  <i className="fa-solid fa-quote-left text-primary fa-2x"></i>
                </div>
                <p className="card-text">“{t.review}”</p>
                <div className="d-flex align-items-center mt-3">
                  <div>
                    <h6 className="mb-0 fw-bold">{t.name}</h6>
                    <div className="text-warning">
                      {[...Array(Math.floor(t.stars))].map((_, i) => (
                        <i key={i} className="fa-solid fa-star"></i>
                      ))}
                      {t.stars % 1 !== 0 && <i className="fa-solid fa-star-half-stroke"></i>}
                      {[...Array(5 - Math.ceil(t.stars))].map((_, i) => (
                        <i key={i} className="fa-regular fa-star"></i>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Video Testimonial */}
        <div className="row mt-5">
          <div className="col-lg-8 mx-auto">
            <h4 className="text-center mb-3">
              <i className="fa-solid fa-video me-2 text-danger"></i>Watch What Our Patients Say
            </h4>
            <div className="ratio ratio-16x9 shadow-sm rounded">
              <div>
                <LiteYouTubeEmbed
                  id="D9tDd5JXNUA"
                  title="What’s new in Material Design for the web (Chrome Dev Summit 2019)"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Write Review Button */}
        <div className="text-center mt-5">
          <a href="https://g.page/r/CUK_1VZZmMpVEAI/review" className="btn btn-custom btn-lg shadow">
            <i className="fa-solid fa-pen-to-square me-2"></i>Write Your Review
          </a>
        </div>
      </section>
      {/* Final CTA */}
      {/* CTA Section */}
      <section className="container my-5">
        <div className="bg-white border shadow rounded p-4">
          <div className="text-center mb-4">
            <h5 className="fw-bold">🎧 Ready to Buy a Hearing Aid?</h5>
          </div>
          <p className="fs-5 text-muted">
            Depending on your needs, preferences, and financial situation, we assist you in selecting the
            appropriate hearing aid for moderate loss, old age, or invisible choices.
          </p>

          <p className="fs-5 text-muted">Explore the latest models from <strong>ReSound, Phonak, Signia,</strong> and other companies.</p>
          <div className="mb-4">
            <h5 className="mb-3">
              <i className="fa-solid fa-magnifying-glass text-primary me-2"></i>
              <strong>Top Searches Our Users Look For:</strong>
            </h5>
            <div className="d-flex flex-wrap gap-2">
              {[
                "Digital hearing machine price",
                "Best hearing aid in Patna",
                "Signia Silk X price",
                "Phonak hearing aid cost",
                "Ear machine price in Patna"
              ].map((item, index) => (
                <span
                  key={index}
                  className="badge bg-light text-dark border px-3 py-2"
                  style={{ fontSize: "0.9rem" }}
                >
                  <i className="fa-solid fa-tags me-1 text-primary"></i> {item}
                </span>
              ))}
            </div>
          </div>

          <div className="sfl-highlight-box text-center mt-4 p-4 rounded">
            <h5 className="sfl-highlight-heading fw-semibold">
              Sound For Life – Your ears deserve the best.
            </h5>
            <p className="sfl-highlight-subtext mt-2">
              Let us help you hear clearly again with the right device near you.
            </p>
          </div>
        </div>
      </section>
      <section className="container my-5">
        <div className="container-fluid py-5" style={{ background: 'linear-gradient(90deg, #006ea1, #006ea1)', color: '#fff' }}>
          <div className="container text-center">
            <h5 className="fw-bold mb-3">
              <i className="fa-solid fa-calendar-check me-2"></i>
              Let’s Help You Hear Again – Contact Us Now!
            </h5>
            <p className="fs-5 mb-4">
              Get the best <strong>digital hearing aids</strong> and <strong>kan sunne wali machine</strong> near you
              at affordable prices from trusted experts.
            </p>

            <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
              <a
                href="tel:+919015401540"
                className="btn btn-warning btn-lg fw-bold px-4 shadow"
              >
                <i className="fa-solid fa-phone me-2"></i> Contact Us
              </a>

              <a
                href="https://wa.me/919015706707"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-light btn-lg fw-bold px-4 text-dark shadow"
              >
                <i className="fa-brands fa-whatsapp me-2"></i> WhatsApp Chat
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />

    </>
  );
};

export default CentrePatna;